import { useQuery } from "@tanstack/react-query";
import { fetchOrganizations } from "@/lib/api";
import { useDashboardOrg } from "@/app/DashboardOrgContext";
import { SearchableSelect } from "@/components/ui/searchable-select";

/**
 * Org switcher for a MULTI-ORG manager — chooses which managed organization the
 * dashboard (units / stats / sessions) is scoped to. Hidden for a system admin
 * (fleet view) and for a manager of a single org (auto-selected). Driver-only
 * orgs never appear — manageableOrgIds is the manager set.
 */
export function DashboardOrgSelector() {
  const { dashboardOrgId, manageableOrgIds, isMultiOrg, setDashboardOrgId } = useDashboardOrg();
  const q = useQuery({ queryKey: ["organizations"], queryFn: fetchOrganizations, enabled: isMultiOrg });

  if (!isMultiOrg) return null;
  const manageable = new Set(manageableOrgIds);
  const orgs = (q.data?.organizations ?? []).filter((o) => manageable.has(o.id));

  return (
    <div data-testid="dashboard-org-selector" className="mr-3">
      <SearchableSelect
        className="w-56"
        options={orgs.map((o) => ({ value: String(o.id), label: o.name }))}
        value={dashboardOrgId != null ? String(dashboardOrgId) : null}
        onValueChange={(v) => setDashboardOrgId(Number(v))}
        placeholder="Select organization…"
        searchPlaceholder="Search organizations…"
        emptyText="No organizations match."
      />
    </div>
  );
}
